import { Input, OnInit, OnChanges, SimpleChanges, SimpleChange, ChangeDetectorRef, Directive } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { Device, IpAddress, MacAddress } from 'DiscoveryEngine.TS/Core';


@Directive()
export abstract class InfoSetViewerComponent<T> implements OnInit, OnChanges {

	@Input()
	public selectedDevice: Device;

	public cols: any[];
	public entries: T[];
	public cmItems: MenuItem[];
	public displaySelectColumnsDialog: boolean;
	public selectItems: SelectItem[];

	constructor(private changeDetector: ChangeDetectorRef) {
		this.cols = [];
		this.entries = [];
		this.cmItems = this.getContextMenuItems();
		this.displaySelectColumnsDialog = false;
		this.selectItems = [];

		this.getCols().forEach((col: any) => {
			if (this.isColumnVisible(col)) {
				this.cols.push(col);
			}
			this.selectItems.push({ label: col.header, value: col });
		}, this);

		// Force infoset viewer to update its contents (bug work-around)
		setTimeout(() => {
			this.updateData();
			this.changeDetector.markForCheck();
		}, 0);
	}

	protected abstract getCols(): any[];

	protected abstract getEntries(): T[];

	protected isColumnVisible(col: any): boolean {
		return true;
	}

	protected getContextMenuItems(): MenuItem[] {
		return [
			{ label: "Select Columns", command: (event) => this.showSelectColumnsDialog() }
		];
	}

	public ngOnInit(): void {
		this.updateData();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change = changes["selectedDevice"];

		if (change) {
			this.updateData();
		}
	}

	private updateData(): void {
		this.entries = this.getEntries();
	}

	private showSelectColumnsDialog(): void {
		this.displaySelectColumnsDialog = true;
	}

	public closeSelectColumnsDialog(): void {
		this.displaySelectColumnsDialog = false;
	}

	public onSelectColumnsDialogHide(): void {
		if (this.cols.length == 0) {
			this.cols.push(this.selectItems[0].value);
			this.changeDetector.detectChanges();
		}
	}

	protected compareStrings(a: string, b: string): number {
		if (a && b)
			return a.localeCompare(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

	protected compareNumbers(a: number, b: number): number {
		if (a !== undefined && b !== undefined)
			return ((a < b) ? -1 : ((a > b) ? 1 : 0));
		else if (a !== undefined)
			return 1;
		else if (b !== undefined)
			return -1;
		else
			return 0;
	}

	protected compareIpAddresses(a: IpAddress, b: IpAddress): number {
		if (a && b)
			return a.CompareTo(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

	protected compareMacAddresses(a: MacAddress, b: MacAddress): number {
		if (a && b)
			return a.CompareTo(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

}
